import React, { useEffect, type FC } from 'react';
import { useTrackElement, useTracking } from '@edreamsodigeo/frontend-core';

import type { PixelTrackingProps } from './types';

/**
 * This component help us do a "fake" component display
 * and launch a datamesh tracking event and an optional google analytics event
 */
const PixelTracking: FC<PixelTrackingProps> = ({
  datameshId,
  googleAnalyticsParams,
}) => {
  const ref = useTrackElement(['display'], datameshId);
  const { trackEvent } = useTracking();

  const { category, action, label } = googleAnalyticsParams || {};

  useEffect(() => {
    if (category && action && label) {
      trackEvent({
        category,
        action,
        label,
      });
    }
  }, [action, category, label, trackEvent]);

  return <div ref={ref} />;
};

export default PixelTracking;
